module.exports = __webpack_public_path__ + "img/The-Impact-of-COVID-19-967x683.f2e0ae9a.png";